<template lang="pug">
.case-container
  .case-content
    .case-case__title
        .divider
        .title__content
          span {{ $t('案例分享：联合利华') }}
          span {{ $t('联合利华是世界上生产快速消费品的主要企业之一。') }}
    .case-case__summary
      div
        i.iconfont.iconhangye
        span {{ $t('广告主行业：快销品') }}

      div
        i.iconfont.iconbumen
        span {{ $t('涉及部门：市场部、采购部、IT部') }}
    .case-case__content__item
        .content__title {{ $t('案例简介：') }}
        .content {{ $t('联合利华营销采购管理平台，收集并整合数据，提供高效的决策建议。') }}

    .case-case__content__item
        .content__title {{ $t('客户当前痛点：') }}
        .content {{ $t('联合利华采购在决策过程中，由于缺少市场参考价、比价过程不透明，审批无依据。') }}

    .case-case__content__item
        .content__title {{ $t('复歌解决方案：') }}
        .content {{ $t('我们为客户搭建了一个营销采购管理平台，通过三大功能解决客户的痛点：') }}
        br
        .content 1）流程管理
        .content Unicase平台在标准化流程管理中，市场部、采购部和供应商三种角色共同参与，执行流程中相应的节点任务，从Brief的创建下发，到供应商报价的审核比较，再到结案后的审核评估，进而推进项目实施。
        .content ①  平台实现了项目的线上管理，保障了多方的高效协作；
        .content ②  多角色线上审核供应商报价，保证了价格的透明化，合规性；
        .content ③  结案后的供应商评价数据，不仅是供应商历史表现的记录，更是作为后续项目的重要参考依据，建立起平台内的正反馈机制。
        br
        .content 2） 数据记录
        .content 项目执行涉及到的资料，包括Brief、供应商的方案报价、KPI、合同及结案报告等数据，都会实时存储在平台上，为后续的业务分析提供完整的数据支持。
        .content ① 平台可以根据不同业务部门或用户角色的需求，定制数据分析报告，满足多种分析场景；
        .content ② 已有项目的相关统计数据会实时反馈在数据仪表盘上，方便用户掌握当前动态及历史表现，为后续业务提供决策支持；
        .content ③ 平台支持与第三方系统对接，提供供应商的工商认证信息、KOL基础信息及参考价格等数据的查询，为项目信息审核提供依据，提高审核效率.
        br
        .content 3） 供应商管理
        .content 平台整合了联合利华已入库的供应商，可根据实际需求查找相关的供应商，查看供应商详细信息，包括基础信息、工商信息、管理团队及客户案例等。
        .content ①  接入的第三方数据，可验证供应商的资质；
        .content ②  平台合作过的项目及结案评分会被记录，通过查看供应商的历史表现，可以更合理更高效的选择供应商。
    .case-case__content__item
        .content__title {{ $t('最终结果：') }}
        .content {{ $t('通过线上流程的标准化管理、项目数据存储记录以及完备的评估体系，将品牌、供应商及第三方的数据进行收集与整合，从而为联合利华提供更快速更高效的市场营销决策建议，以及更透明更有效的供应商管理。') }}
  MobileContact
</template>"
<script>
import MobileContact from '@/components/MobileContact'
export default {
  components: {
    MobileContact
  }
}
</script>
